import styled from 'styled-components';
import { ConsolePanel } from '@/ui';

const Panel = styled(ConsolePanel)`margin-top: 14px; text-align: center; padding: 32px 24px;`;
const H = styled.h3`margin: 0 0 6px; font-family: ${({ theme }) => theme.font.display}; font-size: ${({ theme }) => theme.fontSize.md}; color: ${({ theme }) => theme.color.textPrimary};`;
const P = styled.p`margin: 0; font-family: ${({ theme }) => theme.font.body}; font-size: ${({ theme }) => theme.fontSize.sm}; color: ${({ theme }) => theme.color.textMuted};`;

export function MembersComingSoon() {
  return (
    <Panel>
      <H>Members</H>
      <P>The members directory is coming soon.</P>
    </Panel>
  );
}
